import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import schoolService from '../../services/api/schoolService';
import Paging from '../../components/common/Paging';
import {
  AppContainer,
  BodyContainer,
  MainContentContainer,
} from '../../resources/styling/appStyle';
import { PaginationWrapper } from './SuperAdminStyle';
import { DateFormat } from '../../utils/CommonFunctions';
import { Grid } from '@mui/material';

import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { subDays } from 'date-fns';
import { DateFormats } from '../../utils';
import { SideMenu } from '../../components/layouts/SideMenu';
import { Header } from '../../components/layouts/Header';
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import {
  sa,
  DataTable,
  PillButton,
  SectionHeaderRow,
} from '../../components/superAdminUi';

// The Sent Emails list on the new Super Admin surface: a section header with a Download action,
// a styled keyword search and date-range trigger, and the shared purple-header DataTable.
const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin: ${sa.space.section} 0 15px;
`;

const SearchField = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: ${sa.color.white};
  border: 1px solid ${sa.color.stroke};
  border-radius: ${sa.radius.sm};
  padding: 8px 14px;
  min-width: 280px;

  svg {
    color: ${sa.color.textGray};
    font-size: 18px;
  }
  input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-family: ${sa.font.family};
    font-size: 13px;
    color: ${sa.color.text};
  }
`;

const DateTrigger = styled.input`
  background: ${sa.color.white};
  border: 1px solid ${sa.color.stroke};
  border-radius: ${sa.radius.sm};
  padding: 9px 14px;
  min-width: 240px;
  font-family: ${sa.font.family};
  font-size: 13px;
  font-weight: ${sa.font.semibold};
  color: ${sa.color.text};
  cursor: pointer;
`;

const DatePickerPanel = styled.div`
  position: absolute;
  top: 205px;
  right: 20px;
  z-index: 9999;
  border: 1px solid ${sa.color.stroke};
`;

class SentEmails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageOfItems: [],
      sentEmailsList: [],
      filteredList: [],
      nameSearchValue: '',
      noDataFound: false,
      selectedOption: {
        value: `${DateFormat(
          subDays(new Date(), 30),
          DateFormats.format_31_12_2019
        )} - ${DateFormat(
          subDays(new Date(), 1),
          DateFormats.format_31_12_2019
        )}`,
      },
      isDateRangeOpen: false,
      selectionRange: {
        startDate: subDays(new Date(), 30),
        endDate: subDays(new Date(), 1),
        key: 'selection',
      },
    };
    this.applyFilters = this.applyFilters.bind(this);
    this.handleNameSearchChange = this.handleNameSearchChange.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.dowmloadExcel = this.dowmloadExcel.bind(this);
  }

  componentDidMount() {
    const from = this.state.selectedOption.value;
    this.getSentEmailsWithDateTime(from);
  }
  dowmloadExcel() {
    schoolService
      .downloadSESEmails(
        this.state.nameSearchValue,
        this.state.selectedOption.value
      )
      .then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        link.click();
      });
  }
  onChangePage(pageOfItems) {
    this.setState({ pageOfItems: pageOfItems });
  }
  showData = (response) => {
    if (response.data === null || response.data.length == 0)
      this.setState({ noDataFound: true });
    else this.setState({ noDataFound: false });
    if (response.data != null) {
      this.setState(
        {
          sentEmailsList: response.data,
        },
        this.applyFilters
      );
    }
  };

  getSentEmails() {
    schoolService.getSentEmails().then((response) => {
      this.showData(response);
    });
  }
  getSentEmailsWithDateTime = (val) => {
    schoolService.GetSentEmailsWithDateTime(val).then((response) => {
      this.showData(response);
    });
  };
  applyFilters() {
    const { nameSearchValue, sentEmailsList } = this.state;
    let searchList = sentEmailsList.filter(
      (x) =>
        x.School.Name.toLocaleLowerCase().includes(
          nameSearchValue.toLocaleLowerCase()
        ) ||
        x.EmailTypeDescription.toLocaleLowerCase().includes(
          nameSearchValue.toLocaleLowerCase()
        ) ||
        x.Subject.toLocaleLowerCase().includes(
          nameSearchValue.toLocaleLowerCase()
        ) ||
        x.To.toLocaleLowerCase().includes(nameSearchValue.toLocaleLowerCase())
    );
    this.setState({ filteredList: searchList });
  }
  handleNameSearchChange = (e) => {
    this.setState({ nameSearchValue: e.target.value }, this.applyFilters);
  };

  handleSelect = (ranges) => {
    console.log('ranges', ranges);
    this.setState({
      selectionRange: ranges.selection,
      //isDateRangeOpen: !this.state.isDateRangeOpen,
    });
    const startDate = DateFormat(
      ranges.selection.startDate,
      DateFormats.format_31_12_2019
    );
    const endDate = DateFormat(
      ranges.selection.endDate,
      DateFormats.format_31_12_2019
    );
    //if (startDate !== endDate) {
    const dateRange = `${startDate} - ${endDate}`;
    console.log('dateRange', dateRange);
    this.getSentEmailsWithDateTime(dateRange);
    this.setState({
      selectedOption: {
        value: dateRange,
      },
      //isDateRangeOpen: !this.state.isDateRangeOpen,
    });
    //}
  };
  render() {
    const columns = [
      {
        key: 'date',
        label: 'Date',
        width: '190px',
        render: (item) => new Date(Date.parse(item.CreatedOn)).toDateString(),
      },
      {
        key: 'school',
        label: 'School Name',
        render: (item) => item.School && item.School.Name,
      },
      { key: 'subject', label: 'Subject', render: (item) => item.Subject },
      {
        key: 'type',
        label: 'Email Type',
        render: (item) => item.EmailTypeDescription,
      },
      { key: 'to', label: 'To', render: (item) => item.To },
    ];

    return (
      <AppContainer>
        <SideMenu />
        <BodyContainer>
          <Header />
          <MainContentContainer>
            <SectionHeaderRow title='Sent Emails' size='lg'>
              <PillButton
                type='button'
                $variant='purple'
                $size='lg'
                data-id-div='reportDownload'
                onClick={this.dowmloadExcel}
              >
                <FileDownloadOutlinedIcon style={{ fontSize: 16 }} /> Download
              </PillButton>
            </SectionHeaderRow>

            <Toolbar>
              <SearchField>
                <SearchIcon />
                <input
                  id='searchInputField'
                  placeholder='Enter a keyword'
                  onChange={(e) => {
                    e.preventDefault();
                    this.handleNameSearchChange(e);
                  }}
                />
              </SearchField>

              <div style={{ position: 'relative' }}>
                <DateTrigger
                  value={this.state.selectedOption.value}
                  onChange={(e) => {
                    e.preventDefault();
                  }}
                  onClick={() => {
                    this.setState({
                      isDateRangeOpen: !this.state.isDateRangeOpen,
                    });
                  }}
                  readOnly
                />
              </div>
            </Toolbar>

            {this.state.isDateRangeOpen && (
              <DatePickerPanel>
                <DateRangePicker
                  editableDateInputs={true}
                  ranges={[this.state.selectionRange]}
                  onChange={this.handleSelect}
                  maxDate={new Date()}
                  direction='horizontal'
                  showSelectionPreview={true}
                  moveRangeOnFirstSelection={false}
                  months={2}
                  endDatePlaceholder='Continuo'
                  rangeColors={['#f33e5b', '#3ecf8e', '#fed14c']}
                />
              </DatePickerPanel>
            )}

            <Grid container>
              <Grid item xl={12} lg={12} md={12} sm={12}>
                <DataTable
                  columns={columns}
                  rows={this.state.pageOfItems}
                  getRowKey={(item) => item.Id}
                  empty='No emails found. Please change filters.'
                />
              </Grid>
              <PaginationWrapper>
                <Paging
                  items={this.state.filteredList}
                  onChangePage={this.onChangePage}
                  isChanged={this.state.isChanged}
                />
              </PaginationWrapper>
            </Grid>
          </MainContentContainer>
        </BodyContainer>
      </AppContainer>
    );
  }
}

export default withRouter(SentEmails);
